import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PermitFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const permitTypeOptions = [
    { value: 'all', label: 'All Permit Types' },
    { value: 'Building Permit', label: 'Building Permit' },
    { value: 'Zoning Permit', label: 'Zoning Permit' },
    { value: 'Electrical Permit', label: 'Electrical Permit' },
    { value: 'Plumbing Permit', label: 'Plumbing Permit' },
    { value: 'Mechanical Permit', label: 'Mechanical Permit' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'submission', label: 'Submission' },
    { value: 'under review', label: 'Under Review' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' }
  ];

  const deadlineOptions = [
    { value: 'all', label: 'All Deadlines' },
    { value: 'overdue', label: 'Overdue' },
    { value: 'week', label: 'Within 7 Days' },
    { value: 'month', label: 'Within 30 Days' }
  ];

  const hasActiveFilters = 
    filters?.permitType !== 'all' || 
    filters?.status !== 'all' || 
    filters?.deadline !== 'all' || 
    filters?.search !== '';

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-sm border border-border mb-4 md:mb-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2 md:gap-3">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="font-semibold text-base md:text-lg text-foreground">
            Filter Permits
          </h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <Input
          type="search"
          placeholder="Search permits..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          placeholder="Select permit type"
          options={permitTypeOptions}
          value={filters?.permitType}
          onChange={(value) => onFilterChange('permitType', value)}
        />

        <Select
          placeholder="Select status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Select deadline"
          options={deadlineOptions}
          value={filters?.deadline}
          onChange={(value) => onFilterChange('deadline', value)}
        />
      </div>
    </div>
  );
};

export default PermitFilters;